import script from "./AboutVideoComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutVideoComponent.vue?vue&type=script&setup=true&lang=js"

import "./AboutVideoComponent.vue?vue&type=style&index=0&id=68035ac0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68035ac0"]])

export default __exports__